export default "__VITE_ASSET__Bod61qIb__"